// extracted by mini-css-extract-plugin
export default {"wrapper":"code_wrapper__j0lN2","codeWrapper":"code_codeWrapper__OaFix","infoText":"code_infoText__RE6sm"};